import * as React from "react";
import styled from "styled-components";

import { CouponItemProps } from "..";
import { CouponBtn } from "./CouponBtn";
import { css } from "styled-components";
import { formatBannerSize } from "utils/playground/banner";

// 为cls设置高度
// 宽度固定，高度自适应
const SingleWrapper = styled.div`
	font-size: 0px;
	width: 100%;
	img {
		width: 100%;
		object-fit: fill;
	}
	${(props: { height: string; aspectRatio?: number }) => {
		// 优先按照比例算出宽度，避免图片拉伸
		if (props.aspectRatio) {
			return css`
				height: calc(100vw * ${props.aspectRatio});
				img {
					height: calc(100vw * ${props.aspectRatio});
				}
			`;
		} else if (props.height) {
			return css`
				height: ${props.height};
				img {
					height: ${props.height};
				}
			`;
		}
		return "";
	}}
`;

export const Single = (props: CouponItemProps) => {
	const { coupons = [], ...others } = props;
	return (
		<React.Fragment>
			{coupons.map((item, index) => {
				// 设计稿默认高度240px
				const { width, height = 240 } = item;
				const formatSize = formatBannerSize({ width, height });
				const formatHeight = formatSize?.height;
				const aspectRatio = +formatSize?.aspectRatio || null;
				return (
					<SingleWrapper key={index} height={formatHeight} aspectRatio={aspectRatio}>
						<CouponBtn index={index} coupon={item} {...others} />
					</SingleWrapper>
				);
			})}
		</React.Fragment>
	);
};
